import React, { Component } from 'react';

export default class ToolBarWrapper extends Component {

  setButtonText = (show) => {
    return show === true ? "More Theme" : "Close";
  }

  setClass = (show) => {
    return (show === true) ? "btn-toggle" : "btn-toggle btn-close";
  }

  hiddenMobile = (show) => {
    return (show === true) ? "select-screen" : "select-screen hidden";
  }

  handleScreen = (event) => {
    this.props.handleScreen(event);
  }

  handleCloseTool = () => {
    this.props.handleCloseTool();
  }

  render() {
    return (
      <div className="toolbar-wrapper toolbar-desktop">
        <div className="wrapper-inner">
          <a id="logo" href="https://www.weebpal.com" className="weebpal" title="weebpal.com">
            Weebpal
          </a>

          <div className="current-demo">

            {/* -------- State themes --------- */}
            <Title demos={this.props.currentDemo} />
            <ClassState demos={this.props.currentDemo} />

            {/* --------- Screen mode --------- */}
            <ScreenMode
              show={this.props.show}
              handleScreen={this.handleScreen}
              hiddenMobile={this.hiddenMobile}
            />

          </div>
        </div>

        {/* ------ Main Button ------ */}
        <MainButton
          show={this.props.show}
          setClass={this.setClass}
          handleMoreThemes={this.props.handleMoreThemes}
          setButtonText={this.setButtonText}
          handleCloseTool={this.handleCloseTool}
          demos={this.props.currentDemo}
        />

      </div>
    );
  }
}

const Title = (props) => {
  let demo = props.demos;
  return (
    <h3 className="demo-title">{demo.title}</h3>
  );
}

const ClassState = (props) => {
  let demo = props.demos
  if (demo.class === "") {
    return false;
  } else {
    return <span className="state">{demo.class}</span>
  }
}

const ScreenMode = (props) => {
  let hiddenMobile = props.hiddenMobile;
  let show = props.show;
  return (
    <ul className={hiddenMobile(show)}>
      <li><button className="desktop" href="Desktop" title="Desktop" onClick={props.handleScreen}>tablet</button></li>
      <li><button className="tablet" href="Tablet" title="Tablet" onClick={props.handleScreen}>tablet</button></li>
      <li><button className="vertical-tablet" href="Vertical-Tablet" title="Vertical Tablet" onClick={props.handleScreen}>vertical tablet</button></li>
      <li><button className="mobile" href="Mobile" title="Mobile" onClick={props.handleScreen}>mobile</button></li>
      <li><button className="vertical-mobile" href="Vertical-Mobile" title="Vertical-Mobile" onClick={props.handleScreen}>vertical mobile</button></li>
    </ul>
  );
}

const MainButton = (props) => {
  let show = props.show;
  let handleMoreThemes = props.handleMoreThemes;
  let setClass = props.setClass;
  let setButtonText = props.setButtonText;
  let handleCloseTool = props.handleCloseTool;

  let textbutton = "";
  if (props.demos.price === "") {
    textbutton = "Download";
  } else {
    textbutton = props.demos.price + " Buy Now";
  }

  return (
    <div className="main-button">
      <a href={props.demos.buyLink} className="btn-buy" title="BUY NOW" >
        {textbutton}
      </a>
      <button href="#" className={setClass(show)} onClick={handleMoreThemes}>
        {setButtonText(show)}
      </button>
      <button href="#" className="btn-exit" title="Exit toolbar" onClick={handleCloseTool}>
        Exit
      </button>
    </div >
  );
}


// WEBPACK FOOTER //
// ./src/components/ToolBarWrapper.js